import React from 'react';

const AddIcon = (props) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.7915 2.5C10.1079 2.5 10.3695 2.73501 10.4109 3.04007L10.4167 3.12488L10.4177 9.16667H16.4619C16.8071 9.16667 17.0869 9.4465 17.0869 9.79167C17.0869 10.1081 16.8517 10.3696 16.5467 10.411L16.4619 10.4167H10.4177L10.4193 16.4576C10.4194 16.8028 10.1397 17.0828 9.7945 17.0828C9.47808 17.0828 9.2165 16.8478 9.17508 16.5427L9.16933 16.4578L9.16766 10.4167H3.12683C2.78165 10.4167 2.50183 10.1368 2.50183 9.79167C2.50183 9.47525 2.73696 9.21375 3.04202 9.17233L3.12683 9.16667H9.16766L9.16666 3.12512C9.16658 2.77995 9.44633 2.5 9.7915 2.5Z" fill="#0358A7" />
        </svg>
    );
}

export default AddIcon;